import React from "react";
import "./footer.scss";
import floor from "./floor.svg";
import background from "./background.svg";
import footerAnimation from "./footer-animation.svg";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className="footer-main">
      {/* <div className="footer-box">
        <h2>Nunc neque suspendisse eu amet. Non purus</h2>
        <h2>tincidunt quis in sagittis. Nec eget sed et cursus.</h2>
        <p>
          Think no more. We've got you covered with affordable pricing, simple
        </p>
        <p>documentation and round the clock support</p>
        <button className="button">Get started for free</button>
      </div> */}
      <div className="footer-container">
        <p className="better-way">A Better way to build</p>
        <div className="footer-grid-text">
          <div className="single-column">
            <h3 style={{ color: "#D8553A" }}>Navigation</h3>
            <p>
              <a href="">Home</a>
            </p>
            <p>
              <a href="">About US</a>
            </p>
            <p>
             <a to="feature">Product & Services</a>
              
            </p>
            <p>
              <a href="">Contact Us</a>
            </p>
          </div>



          <div className="single-column">
            <h3 style={{ color: "#D8553A" }}>Features</h3>
            <p>
              <a href="">Library at doorstep </a>
            </p>
            <p>
              <a href="">E-Books</a>
            </p>
            <p>
              <a href="">Daily Quizes</a>
            </p>
            <p>
              <a href="">Magazines</a>
            </p>
            <p>
              <a href="">Yoga & Meditation</a>
            </p>
          </div>

          <div className="single-column">
            <h3 style={{ color: "#D8553A" }}>Policy</h3>
            <p>
              <a href="" onClick={() => navigate("/termCondition")}>Terms & Condition</a>
            </p>
            <p>
              <a href="" onClick={() => navigate("/privacyPolicy")}>Privacy Policy</a>
            </p>
            <p onClick={() => navigate("/shippingPolicy")}>
              <a href="">Shipping Policy</a>
            </p>
            <p onClick={() => navigate("/refundPolicy")}>
              <a href="">Cancellation and Refund</a>
            </p>

          </div>
          <div className="single-column">
            <h3 style={{ color: "#D8553A" }}>Contact Details</h3>
            <p>
              <a href="" >
                FreshPage Technology Pvt ltd
              </a>
            </p>
            <p >
              <a href="">B 18 , jay Shukan Appt , </a>
            </p>
            <p>
              <a href="">Near Holichild School,</a>
            </p>
            <p>
              <a href="">Thakkarnagar, Ahemdabad</a>
            </p>
            <p>
              <a href="">Ph no : +91 9512914914</a>
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Footer;
